import { useState } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import { useSite } from '../context/SiteContext';

const HelpBar = () => {
  const { settings, getImageUrl } = useSite();
  const [open, setOpen] = useState(false);

  if (settings.help_button_enabled === false) return null;

  let blocks = [];
  try {
    blocks = JSON.parse(settings.help_blocks || '[]');
  } catch (e) {
    blocks = [];
  }

  const btnColor = settings.help_button_color || '#2962FF';

  const modal = createPortal(
      <div
        className="fixed inset-0 z-[9999] flex items-center justify-center p-3 sm:p-6"
        style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
        onClick={(e) => e.target === e.currentTarget && setOpen(false)}
        data-testid="help-modal-overlay"
      >
        <div
          className="relative w-full max-w-lg max-h-[85vh] rounded-xl shadow-2xl overflow-hidden flex flex-col"
          style={{ backgroundColor: '#fffdf0' }}
          data-testid="help-modal"
        >
          {/* Notepad header */}
          <div className="flex items-center justify-between px-4 py-3 border-b-2 border-dashed border-amber-300" style={{ backgroundColor: '#fef3c7' }}>
            <h2 className="font-fredoka text-lg sm:text-xl font-bold text-slate-800 flex items-center gap-2">
              📒 {settings.help_title || 'Cómo usar los cupones'}
            </h2>
            <button
              onClick={() => setOpen(false)}
              data-testid="help-modal-close"
              className="p-1.5 rounded-full bg-white/70 hover:bg-white transition-colors"
            >
              <X className="w-4 h-4 text-slate-700" />
            </button>
          </div>

          {/* Notepad body: ruled lines + red margin */}
          <div
            className="overflow-y-auto flex-1 px-6 sm:px-8 py-4 relative"
            style={{
              backgroundImage: 'repeating-linear-gradient(transparent, transparent 27px, #cfe0f0 27px, #cfe0f0 28px)',
              backgroundAttachment: 'local'
            }}
          >
            <div className="absolute top-0 bottom-0 left-4 w-px bg-red-300 pointer-events-none" />
            {blocks.length === 0 ? (
              <p className="text-slate-500 text-sm" style={{ lineHeight: '28px' }}>
                Aún no hay instrucciones. El administrador puede agregarlas desde el panel.
              </p>
            ) : (
              blocks.map((block) => (
                block.type === 'image' ? (
                  block.content && (
                    <div key={block.id} className="my-3 flex justify-center">
                      <img
                        src={getImageUrl(block.content)}
                        alt=""
                        className="max-w-full max-h-64 rounded-lg shadow-md border-4 border-white rotate-[-1deg]"
                        data-testid={`help-image-${block.id}`}
                      />
                    </div>
                  )
                ) : (
                  <p
                    key={block.id}
                    className="text-slate-800 text-sm sm:text-[15px] whitespace-pre-wrap"
                    style={{ lineHeight: '28px' }}
                    data-testid={`help-text-${block.id}`}
                  >
                    {block.content}
                  </p>
                )
              ))
            )}
          </div>
        </div>
      </div>,
      document.body
    );

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        data-testid="help-button"
        className="px-2 py-1 sm:px-3 sm:py-1.5 rounded-full shadow-sm text-white text-[10px] sm:text-sm font-bold flex items-center gap-1 sm:gap-1.5 flex-shrink-0 whitespace-nowrap hover:opacity-90 transition-opacity active:scale-95 leading-tight"
        style={{ backgroundColor: btnColor }}
      >
        {settings.help_button_text || '❓ ¿Cómo usar los cupones?'}
      </button>
      {open && modal}
    </>
  );
};

export default HelpBar;
